import { render } from "./DiagnosticoLOV.vue?vue&type=template&id=d9e912fe&scoped=true"
import script from "./DiagnosticoLOV.vue?vue&type=script&lang=js"
export * from "./DiagnosticoLOV.vue?vue&type=script&lang=js"

import "./DiagnosticoLOV.vue?vue&type=style&index=0&id=d9e912fe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e912fe"]])

export default __exports__